module.exports = __webpack_public_path__ + "img/Mask Group@2x.610e64e0.png";